/*
  Fator 5 — Influencers (sections/promo-grid.liquid): carrossel com o card do meio no computador (1280px ou mais),
  fileira de círculos (stories) no celular e no tablet (até 1279px), prévias em vídeo e o player de stories.
  Antes vinha embutido no HTML da home (52 KB em toda visita, lidos antes de a página aparecer). Aqui fica em
  cache e roda com defer, depois que o HTML termina de chegar. Liga cada vitrine [data-promo] uma vez só; no
  editor de temas, liga a seção que o editor acabou de recriar.
*/
(function () {
  if (window.F5PromoGrid) return;   /* a seção pode aparecer mais de uma vez na página */

  function liga(host) {
    if (!host || host.hasAttribute('data-promo-ligado')) return;
    host.setAttribute('data-promo-ligado', '');
    var track = host.querySelector('[data-promo-track]');
    if (!track) return;

    /* ---------- Carrossel com o card do meio fixo ----------
       O card grande NÃO anda: ele fica parado no centro e os vídeos é que entram nele quando se clica na
       seta. Para isso o trilho precisa ser mais largo que a tela, então a lista de tiles é repetida (a
       Aline autorizou repetir os produtos quando os vídeos acabarem) e a rolagem "dá a volta" sem fim:
       ao chegar perto da ponta, o trilho salta um ciclo inteiro — como o conteúdo se repete, o salto é
       invisível. Os tiles repetidos ficam fora da lista do player e dos leitores de tela. */
    var listaTiles = [], tilesOriginais = [], ativo = 0, destaqueInicial = 0;
    var ciclos = 1, larguraCiclo = 0, ajustando = false, temVideoNaLista = false;

    /* No celular e no tablet (até 1279px, a mesma faixa do cabeçalho) a vitrine é outra: uma fileira de
       círculos (stories), sem card fixo no meio, sem repetição dos tiles e sem setas — igual ao oficial.
       Tem de bater com o @media (max-width: 1279px) de sections/promo-grid.liquid. */
    var telaDeCirculos = window.matchMedia ? window.matchMedia('(max-width: 1279px)') : null;
    function emCirculos() { return !!(telaDeCirculos && telaDeCirculos.matches); }

    function guardaOriginais() {
      if (tilesOriginais.length) return;
      var nodes = track.querySelectorAll('.promo-tile');
      for (var i = 0; i < nodes.length; i++) tilesOriginais.push(nodes[i]);
      destaqueInicial = Math.floor(tilesOriginais.length / 2);
      for (var j = 0; j < tilesOriginais.length; j++) {
        if (tilesOriginais[j].classList.contains('promo-tile--big')) { destaqueInicial = j; break; }
      }
    }
    function repeteTiles() {
      guardaOriginais();
      if (ciclos > 1 || tilesOriginais.length < 2) return;
      var passo = 0;
      for (var i = 0; i < tilesOriginais.length; i++) passo += tilesOriginais[i].offsetWidth + 28;
      if (!passo) return;                                   /* layout ainda não pronto */
      ciclos = Math.max(3, Math.ceil((track.clientWidth * 2) / passo) + 2);
      var pacote = document.createDocumentFragment();
      for (var c = 1; c < ciclos; c++) {
        for (var j = 0; j < tilesOriginais.length; j++) {
          var copia = tilesOriginais[j].cloneNode(true);
          copia.setAttribute('data-vs-clone', '');
          copia.setAttribute('aria-hidden', 'true');        /* repetição não é anunciada duas vezes */
          copia.classList.remove('promo-tile--big');
          copia.classList.remove('promo-tile--preview-on');
          var previa = copia.querySelector('[data-vs-preview]');
          if (previa) previa.innerHTML = '';
          var focaveis = copia.querySelectorAll('a, button');
          for (var f = 0; f < focaveis.length; f++) focaveis[f].setAttribute('tabindex', '-1');
          pacote.appendChild(copia);
        }
      }
      track.appendChild(pacote);
      larguraCiclo = passo;
    }
    function mapeiaTiles() {
      listaTiles = [];
      temVideoNaLista = false;
      var nodes = track.querySelectorAll('.promo-tile');
      for (var i = 0; i < nodes.length; i++) {
        listaTiles.push(nodes[i]);
        if (nodes[i].hasAttribute('data-vs-item')) temVideoNaLista = true;
      }
    }
    function centraliza(el, suave) {
      var destino = Math.max(0, el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2);
      if (suave && track.scrollTo) track.scrollTo({ left: destino, behavior: 'smooth' });
      else track.scrollLeft = destino;
    }
    function atualizaSetas() {
      var semFim = ciclos > 1;
      if (p) p.disabled = !semFim && ativo <= 0;
      if (n) n.disabled = !semFim && ativo >= listaTiles.length - 1;
    }
    function marcaDestaque(i) {
      for (var k = 0; k < listaTiles.length; k++) listaTiles[k].classList.toggle('promo-tile--big', k === i);
      ativo = i;
      atualizaSetas();
      /* no computador só o card do meio toca: trocou o destaque (seta ou arrasto), troca a prévia */
      if (typeof agendaAtualizacao === 'function') agendaAtualizacao();
    }
    function saltaCiclo(direcao) {                          /* invisível: o conteúdo é o mesmo */
      if (!larguraCiclo) return;
      ajustando = true;
      track.scrollLeft += direcao * larguraCiclo;
      window.setTimeout(function () { ajustando = false; }, 80);
    }
    /* A seta anda até o próximo tile COM vídeo — é o vídeo que precisa chegar ao card do meio.
       Os tiles sem vídeo continuam aparecendo de lado; só não param no centro. Se nenhum tile tiver
       vídeo, anda de um em um. */
    /* Traz o destaque de volta para o ciclo do meio, sem a pessoa perceber (o conteúdo se repete, então
       deslocar índice e rolagem em um ciclo inteiro não muda nada na tela). Feito ANTES de cada passo:
       assim o trilho nunca encosta na ponta — era o que travava a seta depois de alguns cliques. */
    function voltaAoCicloDoMeio() {
      if (ciclos < 3 || !larguraCiclo || !tilesOriginais.length) return;
      var porCiclo = tilesOriginais.length;
      var delta = Math.floor(ciclos / 2) - Math.floor(ativo / porCiclo);
      if (!delta) return;
      var novo = ativo + delta * porCiclo;
      if (novo < 0 || novo >= listaTiles.length) return;
      ajustando = true;
      track.scrollLeft += delta * larguraCiclo;
      marcaDestaque(novo);
      window.setTimeout(function () { ajustando = false; }, 80);
    }
    function anda(direcao) {
      if (!listaTiles.length) return;
      if (emCirculos()) {                                   /* círculos: a seta só desliza a fileira */
        var salto = direcao * Math.round(track.clientWidth * 0.8);
        if (track.scrollBy) track.scrollBy({ left: salto, behavior: 'smooth' });
        else track.scrollLeft += salto;
        if (typeof agendaAtualizacao === 'function') agendaAtualizacao();
        return;
      }
      voltaAoCicloDoMeio();
      var i = ativo;
      for (var passos = 0; passos < listaTiles.length; passos++) {
        i += direcao;
        if (ciclos > 1) {
          if (i < 0) { saltaCiclo(1); i += tilesOriginais.length; }
          else if (i >= listaTiles.length) { saltaCiclo(-1); i -= tilesOriginais.length; }
        }
        if (i < 0 || i >= listaTiles.length) return;
        if (!temVideoNaLista || listaTiles[i].hasAttribute('data-vs-item')) break;
      }
      marcaDestaque(i);
      centraliza(listaTiles[i], true);
      if (typeof agendaAtualizacao === 'function') agendaAtualizacao();   /* as prévias acompanham */
    }
    /* Arrasto manual: se a rolagem chegar perto de uma ponta, salta um ciclo (invisível).
       A ponta da direita é medida pelo fim de verdade do trilho (scrollWidth), com a mesma folga de meio
       ciclo da esquerda. Antes era larguraCiclo * (ciclos - 1.5), que em telas de ~1366px caía em cima
       do último card do ciclo do meio: parar nele fazia o trilho saltar para a cópia, e o vídeo do meio
       recomeçava do zero. */
    function normalizaRolagem() {
      if (ciclos < 3 || !larguraCiclo) return;
      var fim = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft < larguraCiclo * 0.5) saltaCiclo(1);
      else if (track.scrollLeft > fim - larguraCiclo * 0.5) saltaCiclo(-1);
    }
    /* Rolagem manual (arrasto/roda): o destaque é sempre o tile mais próximo do centro */
    function destaqueSegueRolagem() {
      if (!listaTiles.length || emCirculos()) return;       /* nos círculos nenhum tile é o destaque */
      var centro = track.scrollLeft + track.clientWidth / 2, melhor = 0, menor = Infinity;
      for (var i = 0; i < listaTiles.length; i++) {
        var meio = listaTiles[i].offsetLeft + listaTiles[i].offsetWidth / 2;
        var dist = Math.abs(meio - centro);
        if (dist < menor) { menor = dist; melhor = i; }
      }
      if (melhor !== ativo) marcaDestaque(melhor);
    }

    var p = host.querySelector('[data-promo-prev]'), n = host.querySelector('[data-promo-next]');
    guardaOriginais();
    mapeiaTiles();
    ativo = destaqueInicial;
    atualizaSetas();
    if (p) p.addEventListener('click', function () { anda(-1); });
    if (n) n.addEventListener('click', function () { anda(1); });
    var relogioRolagem = null;
    track.addEventListener('scroll', function () {
      if (relogioRolagem) return;
      relogioRolagem = window.setTimeout(function () {
        relogioRolagem = null;
        if (ajustando) return;
        normalizaRolagem();
        destaqueSegueRolagem();
      }, 120);
    }, { passive: true });

    /* Celular e tablet: sem repetição e sem destaque — a fileira de círculos começa no primeiro vídeo */
    function removeRepeticoes() {
      var copias = track.querySelectorAll('[data-vs-clone]');
      for (var i = 0; i < copias.length; i++) {
        if (copias[i].parentNode) copias[i].parentNode.removeChild(copias[i]);
      }
      ciclos = 1;
      larguraCiclo = 0;
    }
    function preparaCirculos() {
      guardaOriginais();
      removeRepeticoes();
      mapeiaTiles();
      for (var i = 0; i < listaTiles.length; i++) listaTiles[i].classList.remove('promo-tile--big');
      ativo = 0;
      track.scrollLeft = 0;
      if (typeof registraPrevias === 'function') registraPrevias();
    }

    // No carregamento: repete os tiles (para o trilho poder girar) e põe o destaque inicial no centro
    function preparaCarrossel() {
      if (emCirculos()) { preparaCirculos(); return; }
      repeteTiles();
      mapeiaTiles();
      if (!listaTiles.length) return;
      var alvo = Math.floor(ciclos / 2) * tilesOriginais.length + destaqueInicial;
      if (alvo >= listaTiles.length) alvo = Math.min(destaqueInicial, listaTiles.length - 1);
      /* se o tile marcado como destaque no editor não tiver vídeo, começa no vídeo mais próximo dele */
      if (temVideoNaLista && !listaTiles[alvo].hasAttribute('data-vs-item')) {
        for (var d = 1; d < listaTiles.length; d++) {
          if (listaTiles[alvo + d] && listaTiles[alvo + d].hasAttribute('data-vs-item')) { alvo = alvo + d; break; }
          if (listaTiles[alvo - d] && listaTiles[alvo - d].hasAttribute('data-vs-item')) { alvo = alvo - d; break; }
        }
      }
      marcaDestaque(alvo);
      centraliza(listaTiles[alvo], false);
      if (typeof registraPrevias === 'function') registraPrevias();   /* os repetidos também tocam */
    }
    /* No editor do tema o script roda de novo com a página já carregada. Aí preparaCarrossel vai para a
       fila (setTimeout 0) e só roda DEPOIS do resto deste script: ela usa variáveis declaradas mais abaixo
       (a lista de prévias, as expressões que leem os links de vídeo). Chamada na hora, elas ainda estavam
       vazias: dava erro e o resto do script não rodava (no editor, nenhum card tocava nem abria o player). */
    if (document.readyState === 'complete') window.setTimeout(preparaCarrossel, 0);
    else window.addEventListener('load', preparaCarrossel);

    /* Girou o telefone ou o tablet / mudou a largura: monta o layout da vez (círculos ou carrossel) */
    if (telaDeCirculos) {
      var trocaDeLayout = function () { preparaCarrossel(); };
      if (telaDeCirculos.addEventListener) telaDeCirculos.addEventListener('change', trocaDeLayout);
      else if (telaDeCirculos.addListener) telaDeCirculos.addListener(trocaDeLayout);
    }

    // Adicionar ao carrinho pelo mini-card (quando há produto real)
    host.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-promo-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      addToCart(btn.getAttribute('data-promo-add')).catch(function () {});
    });

    function addToCart(id) {
      if (!id) return Promise.reject();
      var cart = window.F5Cart;
      if (cart && typeof cart.addItems === 'function') {
        return Promise.resolve(cart.addItems([{ id: id, quantity: 1 }])).then(function () {
          if (typeof cart.open === 'function') cart.open();
        });
      }
      return fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        // formato de lista: no de um item só a Shopify não confere o estoque (ver assets/cart.js)
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); }).then(function () {
        var opener = document.querySelector('[data-cart-open]');
        if (opener) opener.click();
      });
    }

    /* ---------- Provedores de vídeo (mesmas regras do player do produto) ---------- */
    var RE_VIMEO = /vimeo\.com\/(?:.*\/)?(\d+)/i;
    /* Formas diretas (vimeo.com/ID, vimeo.com/ID/HASH, player.vimeo.com/video/ID), com o caminho terminando ali.
       Testada antes da regex gulosa: em vimeo.com/ID/HASH com HASH começando por dígito ela pegaria o hash. */
    var RE_VIMEO_DIRETO = /vimeo\.com\/(?:video\/)?(\d+)(?:\/([0-9a-f]{6,}))?\/?(?:[?#]|$)/i;
    /* Galeria (showcase/álbum): o número do caminho é da GALERIA, não de um vídeo — e costuma coincidir
       com o id de um vídeo de terceiros. Só vale se o link disser qual vídeo (?video=ID ou /video/ID). */
    var RE_VIMEO_GALERIA = /vimeo\.com\/(?:showcase|album)\//i;
    var RE_VIMEO_ID_BUSCA = /[?&]video=(\d+)/i;
    var RE_VIMEO_ID_CAMINHO = /\/video\/(\d+)/i;
    var RE_VIMEO_HASH = /[?&]h=([0-9a-z]+)/i;
    var RE_YT = /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/shorts\/|youtube\.com\/embed\/|youtube\.com\/live\/)([\w-]+)/i;
    function parseVideo(url) {
      if (typeof url !== 'string') return null;
      url = url.trim();
      if (!url) return null;
      var h = url.match(RE_VIMEO_HASH);
      var hash = h ? h[1] : '';
      if (RE_VIMEO_GALERIA.test(url)) {
        var g = url.match(RE_VIMEO_ID_BUSCA) || url.match(RE_VIMEO_ID_CAMINHO);
        return g ? { provider: 'vimeo', id: g[1], hash: hash } : null;
      }
      var m = url.match(RE_VIMEO_DIRETO) || url.match(RE_VIMEO);
      if (m) return { provider: 'vimeo', id: m[1], hash: m[2] || hash };
      m = url.match(RE_YT);
      if (m) return { provider: 'youtube', id: m[1], hash: '' };
      return null;
    }
    /* Vídeo enviado para a Shopify: o próprio arquivo. Sem ele, vale o link do YouTube/Vimeo. */
    function videoDoTile(el) {
      if (el.getAttribute('data-vs-provider') === 'shopify') {
        var mp4 = el.getAttribute('data-vs-src') || '';
        if (mp4) return { provider: 'shopify', src: mp4, hls: el.getAttribute('data-vs-hls') || '' };
      }
      return parseVideo(el.getAttribute('data-vs-url'));
    }
    /* A Liquid só entrega a lista HLS e a mp4 maior. As outras mp4 existem no mesmo endereço, com o
       nome que a própria lista HLS dá a cada versão: '.SD-480p.1.2Mbps.hls.123_.m3u8' vira
       '.SD-480p-1.2Mbps-123.mp4'. Lemos a lista (640 bytes, em cache por um ano, CORS liberado) e
       montamos o nome exato — sem chutar a taxa, que muda de vídeo para vídeo. */
    var RE_VERSAO_HLS = /\.((?:SD|HD)-\d+p)\.([\d.]+Mbps)\.hls\.(\d+)_\.m3u8$/;
    var versoesPorLista = {};
    function versoesDoVideo(hls) {
      if (!hls || !window.fetch) return Promise.resolve([]);
      if (versoesPorLista[hls]) return versoesPorLista[hls];
      var pasta = hls.slice(0, hls.lastIndexOf('/') + 1);
      versoesPorLista[hls] = fetch(hls)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (txt) {
          var linhas = txt.split(/\r?\n/), lista = [];
          for (var i = 0; i < linhas.length - 1; i++) {
            var res = /RESOLUTION=(\d+)x(\d+)/.exec(linhas[i]);
            if (!res) continue;
            var nome = linhas[i + 1].trim();
            var m = RE_VERSAO_HLS.exec(nome);
            if (!m) continue;
            var mp4 = nome.slice(0, m.index) + '.' + m[1] + '-' + m[2] + '-' + m[3] + '.mp4';
            if (!/^(https?:)?\/\//.test(mp4)) mp4 = pasta + mp4;
            lista.push({ altura: +res[2], url: mp4 });
          }
          return lista.sort(function (a, b) { return a.altura - b.altura; });
        })
        .catch(function () { return []; })
        .then(function (lista) {
          /* rede oscilando ou erro da CDN não fica guardado: a próxima montagem tenta de novo */
          if (!lista.length) delete versoesPorLista[hls];
          return lista;
        });
      return versoesPorLista[hls];
    }
    /* A menor versão com pelo menos `minimo` px de ALTURA — é pela altura que a Shopify nomeia as versões
       (270x480 é a 480p; num vídeo deitado, 854x480 também é a 480p) e é a altura que o tile em pé usa.
       Sem lista, a mp4 que a Liquid entregou. */
    function escolheVersao(v, minimo) {
      return versoesDoVideo(v.hls).then(function (lista) {
        for (var i = 0; i < lista.length; i++) { if (lista[i].altura >= minimo) return lista[i].url; }
        return lista.length ? lista[lista.length - 1].url : v.src;
      });
    }
    /* Capa automática: YouTube tem URL fixa; Vimeo responde pelo oEmbed oficial.
       O oEmbed do Vimeo entrega a capa com sufixo de corte DEITADO (…-d_295x166) mesmo em vídeo em pé —
       no tile de 286x508 (object-fit: cover) isso ampliava a imagem ~3x. Trocando o sufixo, o próprio CDN
       devolve o corte em pé já no tamanho certo (conferido: -d_640x1138 responde 640x1138). */
    var CAPA_VIMEO = '-d_640x1138';   /* tile 286x508, com folga para telas retina */
    function capaEmPe(url) {
      return typeof url === 'string' ? url.replace(/-d_\d+x\d+/i, CAPA_VIMEO) : url;
    }
    function resolvePoster(v) {
      if (!v) return Promise.resolve(null);
      if (v.provider === 'shopify') return Promise.resolve(null);   /* a capa já vem do arquivo, no Liquid */
      if (v.provider === 'youtube') return Promise.resolve('https://i.ytimg.com/vi/' + v.id + '/hqdefault.jpg');
      var pagina = 'https://vimeo.com/' + v.id + (v.hash ? '/' + v.hash : '');   /* não listado: o oEmbed precisa do hash */
      return fetch('https://vimeo.com/api/oembed.json?url=' + encodeURIComponent(pagina) + '&width=520')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return (j && capaEmPe(j.thumbnail_url)) || null; })
        .catch(function () { return null; });
    }
    function embedSrc(v, muted) {
      if (!v) return 'about:blank';
      if (v.provider === 'vimeo') {
        return 'https://player.vimeo.com/video/' + v.id + '?autoplay=1&muted=' + (muted ? 1 : 0) + '&autopause=0&controls=0&title=0&byline=0&portrait=0&playsinline=1' + (v.hash ? '&h=' + v.hash : '');
      }
      return 'https://www.youtube.com/embed/' + v.id + '?autoplay=1&mute=' + (muted ? 1 : 0) + '&controls=0&playsinline=1&rel=0&modestbranding=1&enablejsapi=1';
    }

    /* ---------- Lê os tiles de vídeo (na ordem do DOM) ---------- */
    // Capa automática a partir do link (só quando não há capa enviada) — vale para os repetidos também
    function aplicaCapaAutomatica(el, v) {
      var poster = el.querySelector('[data-vs-poster-auto]');
      if (!poster) return;
      resolvePoster(v).then(function (src) {
        if (!src) return;
        var probe = new Image();
        probe.onload = function () { poster.src = src; poster.removeAttribute('srcset'); };
        probe.src = src;
      });
    }

    var items = [];
    (function () {
      var tiles = track.querySelectorAll('[data-vs-item]:not([data-vs-clone])');
      for (var i = 0; i < tiles.length; i++) {
        var el = tiles[i];
        var btn = el.querySelector('[data-vs-open]');
        var v = videoDoTile(el);
        if (!v) {
          // link não reconhecido: o tile continua na vitrine, mas não abre player
          if (btn) btn.removeAttribute('data-vs-open');
          continue;
        }
        items.push({
          v: v,
          el: el,
          frame: null,
          title: el.getAttribute('data-vs-title') || '',
          name: el.getAttribute('data-vs-name') || '',
          price: el.getAttribute('data-vs-price') || '',
          url: el.getAttribute('data-vs-url-product') || '#',
          variant: el.getAttribute('data-vs-variant') || ''
        });
        // o índice do botão passa a ser a posição real dentro de items
        if (btn) btn.setAttribute('data-vs-open', String(items.length - 1));
        aplicaCapaAutomatica(el, v);
      }
    })();

    if (!items.length) return;

    /* ---------- Prévias em vídeo nos tiles (como o oficial: mudas, em loop) ----------
       Regras: só monta o que está à vista (medido por posição, não por observador — funciona mesmo quando
       o navegador congela o ciclo de renderização), no máximo maxPrevias() ao mesmo tempo, e só depois do
       'load' + momento ocioso, para não disputar banda com a primeira dobra. Quem pediu "reduzir movimento"
       ou está em economia de dados continua vendo a capa com o selo de play.
       No computador só o card do meio (o destaque) toca; os de lado ficam na capa com o selo de play e
       começam a tocar quando a seta ou o arrasto os traz para o meio (pedido da Aline em 04/10).
       Nos círculos (celular e tablet, até 1279px) nenhum vídeo toca sozinho (item 1.4, decisão da Aline em 16/10;
       estendida ao tablet depois): fica a capa no círculo, como um story, e o vídeo só roda quando a cliente toca
       no círculo e o player abre. Antes tocavam até 4 à vista, e quem só rolava a página baixava os vídeos; o
       oficial toca sozinho, então aqui perde a paridade de propósito. Ao girar para a largura de computador, o
       destaque volta a tocar.
       O som nunca toca aqui: quem quiser som clica no tile e liga no player. */
    function maxPrevias() { return emCirculos() ? 0 : 1; }   /* círculos: nenhum; computador: só o destaque */
    function soODestaque() { return !emCirculos(); }
    var MARGEM_PREVIA = 150;
    var previas = [];              /* um registro por TILE na tela (originais + repetidos) */
    var previasNoAr = [];
    var previasLigadas = false;
    var agendado = null;

    /* (Re)monta a lista de tiles que podem tocar — chamada de novo depois da repetição dos tiles */
    function registraPrevias() {
      if (!items.length) return;   /* sem vídeo válido o script parou antes do 'var previas = []' */
      for (var i = 0; i < previas.length; i++) desmontaPrevia(previas[i]);
      previas = [];
      var nodes = track.querySelectorAll('[data-vs-item]');
      for (var j = 0; j < nodes.length; j++) {
        var v = videoDoTile(nodes[j]);
        if (!v) continue;
        var reg = { el: nodes[j], v: v, frame: null,
                    title: nodes[j].getAttribute('data-vs-title') || '',
                    name: nodes[j].getAttribute('data-vs-name') || '' };
        previas.push(reg);
        if (nodes[j].hasAttribute('data-vs-clone')) aplicaCapaAutomatica(nodes[j], v);
      }
      atualizaPrevias();
    }
    var semMovimento = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    var economiaDeDados = !!(navigator.connection && navigator.connection.saveData);

    function previewSrc(v) {
      if (v.provider === 'vimeo') {
        /* background=1 já implica mudo, em loop, sem controles */
        return 'https://player.vimeo.com/video/' + v.id + '?background=1&autoplay=1&muted=1&loop=1&autopause=0&playsinline=1' + (v.hash ? '&h=' + v.hash : '');
      }
      return 'https://www.youtube.com/embed/' + v.id + '?autoplay=1&mute=1&loop=1&playlist=' + v.id + '&controls=0&disablekb=1&fs=0&modestbranding=1&rel=0&iv_load_policy=3&playsinline=1';
    }
    /* Só revela a prévia quando o vídeo REALMENTE começa a tocar. Se o aparelho bloquear o autoplay
       (iPhone no Modo de Pouca Energia, economia de dados, navegador dentro de app), o iframe carrega do
       mesmo jeito — revelar no 'load' deixava um quadro CONGELADO por cima da capa e ainda escondia o
       selo de play. Sem sinal de reprodução em ESPERA_PREVIA, a prévia sai e a capa volta com o selo. */
    var ESPERA_PREVIA = 3000;
    function pedeAvisoDeReproducao(f) {
      var w = f.contentWindow;
      if (!w) return;
      try {
        w.postMessage(JSON.stringify({ method: 'addEventListener', value: 'play' }), '*');
        w.postMessage(JSON.stringify({ method: 'addEventListener', value: 'timeupdate' }), '*');
      } catch (e) {}
    }
    function tocandoNaPrevia(e) {
      for (var i = 0; i < previasNoAr.length; i++) {
        var it = previasNoAr[i];
        if (!it.frame || e.source !== it.frame.contentWindow) continue;
        var d = e.data;
        if (typeof d === 'string') { try { d = JSON.parse(d); } catch (err) { return; } }
        if (!d || typeof d !== 'object') return;
        /* o player só aceita o pedido depois de avisar que está pronto: repete aqui, por garantia */
        if (d.event === 'ready') { pedeAvisoDeReproducao(it.frame); armaEspera(it, it.frame); return; }
        if (d.event !== 'play' && d.event !== 'playProgress' && d.event !== 'timeupdate') return;
        if (it.espera) { window.clearTimeout(it.espera); it.espera = null; }
        it.el.classList.add('promo-tile--preview-on');
        return;
      }
    }
    window.addEventListener('message', tocandoNaPrevia);

    /* O relógio só vale para o Vimeo, que sabe avisar que começou. Ele é rearmado quando o
       player fica pronto: assim a espera conta a partir daí, e não do momento em que o
       iframe entrou na página — em rede lenta o download inteiro cabia dentro dos 3s. */
    function armaEspera(it, f) {
      if (it.espera) { window.clearTimeout(it.espera); }
      it.espera = window.setTimeout(function () {
        if (it.frame !== f) { return; }
        it.desistiu = true;   /* não adianta remontar a cada rolagem: aqui o vídeo não vai tocar */
        desmontaPrevia(it);
      }, ESPERA_PREVIA);
    }

    /* Prévia com vídeo da Shopify: um <video> nosso, mudo e em loop. No círculo (celular e tablet) vai a menor
       versão (480p, ~4,7 MB por 30s); no tile do computador, a de 720p. Só aparece quando está tocando
       de verdade ('playing'); até lá fica a capa, sem quadro congelado.
       Se o aparelho barrar o autoplay (Modo de Pouca Energia), nada é baixado (preload=none) e o vídeo
       espera o primeiro toque da pessoa na página: dentro de um toque o iPhone deixa tocar um vídeo nosso
       — o do Vimeo, dentro de iframe, não. O mesmo <video> é reaproveitado ao voltar à tela, porque a
       liberação do aparelho fica presa ao elemento. */
    var esperandoToque = [];
    var toqueLigado = false;
    function ligaPrimeiroToque() {
      if (toqueLigado) return;
      toqueLigado = true;
      document.addEventListener('touchend', aoToque, { capture: true, passive: true });
      document.addEventListener('click', aoToque, { capture: true, passive: true });
    }
    function aoToque() {
      var fila = esperandoToque.slice();
      esperandoToque = [];
      for (var i = 0; i < fila.length; i++) tocaOuEspera(fila[i]);
    }
    function tocaOuEspera(it) {
      var v = it.frame;
      if (!v || v.tagName !== 'VIDEO' || !v.getAttribute('src')) return;
      var pr;
      try { pr = v.play(); } catch (e) { pr = null; }
      if (!pr || !pr.catch) return;
      pr.catch(function () {
        if (it.frame !== v || esperandoToque.indexOf(it) >= 0) return;
        esperandoToque.push(it);
        ligaPrimeiroToque();
      });
    }
    function montaPreviaNativa(it, caixa) {
      var v = it.video;
      if (!v) {
        v = document.createElement('video');
        v.muted = true;
        v.defaultMuted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('loop', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('preload', 'none');
        v.setAttribute('aria-hidden', 'true');
        v.setAttribute('tabindex', '-1');
        v.addEventListener('playing', function () { if (it.frame === v) it.el.classList.add('promo-tile--preview-on'); });
        /* a versão menor não abriu: vai a mp4 que a Liquid garantiu */
        v.addEventListener('error', function () {
          if (it.frame !== v || v.getAttribute('src') === it.v.src) return;
          v.src = it.v.src;
          tocaOuEspera(it);
        });
        it.video = v;
      }
      caixa.appendChild(v);
      it.frame = v;
      previasNoAr.push(it);
      while (previasNoAr.length > maxPrevias()) desmontaPrevia(previasNoAr[0]);
      escolheVersao(it.v, emCirculos() ? 0 : 720).then(function (url) {
        if (it.frame !== v) return;   /* saiu da tela enquanto a lista chegava */
        v.src = url;
        tocaOuEspera(it);
      });
    }

    function montaPrevia(it) {
      if (!it || it.frame || it.desistiu) return;
      var caixa = it.el.querySelector('[data-vs-preview]');
      if (!caixa) return;
      if (it.v.provider === 'shopify') { montaPreviaNativa(it, caixa); return; }
      var f = document.createElement('iframe');
      f.setAttribute('title', 'Prévia do vídeo: ' + (it.title || it.name || ''));
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('tabindex', '-1');
      f.setAttribute('frameborder', '0');
      f.setAttribute('allow', 'autoplay; encrypted-media');
      f.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      f.addEventListener('load', function () {
        if (it.frame !== f) return;
        /* YouTube mudo em loop engata em qualquer aparelho: segue revelando no 'load'. */
        if (it.v.provider !== 'vimeo') { it.el.classList.add('promo-tile--preview-on'); return; }
        pedeAvisoDeReproducao(f);
      });
      f.src = previewSrc(it.v);
      caixa.appendChild(f);
      it.frame = f;
      if (it.v.provider === 'vimeo') { armaEspera(it, f); }
      previasNoAr.push(it);
      while (previasNoAr.length > maxPrevias()) desmontaPrevia(previasNoAr[0]);
    }
    function desmontaPrevia(it) {
      if (!it) return;
      if (it.espera) { window.clearTimeout(it.espera); it.espera = null; }
      if (!it.frame) return;
      it.el.classList.remove('promo-tile--preview-on');
      if (it.frame.tagName === 'VIDEO') {
        /* para o download de verdade: sem src + load() o navegador solta a conexão */
        try { it.frame.pause(); it.frame.removeAttribute('src'); it.frame.load(); } catch (e) {}
        var naFila = esperandoToque.indexOf(it);
        if (naFila >= 0) esperandoToque.splice(naFila, 1);
      } else {
        try { it.frame.src = 'about:blank'; } catch (e) {}
      }
      if (it.frame.parentNode) it.frame.parentNode.removeChild(it.frame);
      it.frame = null;
      var i = previasNoAr.indexOf(it);
      if (i >= 0) previasNoAr.splice(i, 1);
    }
    function desmontaTodasAsPrevias() { while (previasNoAr.length) desmontaPrevia(previasNoAr[0]); }

    /* Está à vista? dentro do trilho na horizontal e dentro da janela na vertical, com folga */
    function tileAVista(el) {
      var r = el.getBoundingClientRect(), t = track.getBoundingClientRect();
      var alturaJanela = window.innerHeight || document.documentElement.clientHeight || 0;
      if (!r.width || !r.height) return false;
      if (r.right <= t.left - MARGEM_PREVIA || r.left >= t.right + MARGEM_PREVIA) return false;
      return r.bottom > -MARGEM_PREVIA && r.top < alturaJanela + MARGEM_PREVIA;
    }
    /* As vagas de prévia vão primeiro para quem está DE FATO na tela; a folga (MARGEM_PREVIA)
       só entra com o que sobrar. Nos círculos a folga cobre uns 8 círculos e há só 4 vagas: na
       ordem da página, os círculos já rolados para fora seguravam as vagas e os que estavam na
       tela ficavam parados. Quem sai da fila perde a vaga, para ela ir para quem está à vista. */
    function atualizaPrevias() {
      if (!previasLigadas || st.open) return;
      var naTela = [], perto = [];
      var t = track.getBoundingClientRect();
      for (var i = 0; i < previas.length; i++) {
        var it = previas[i];
        if (!tileAVista(it.el)) { desmontaPrevia(it); continue; }
        if (it.desistiu) continue;   /* aparelho que não toca: não ocupa vaga */
        if (soODestaque() && !it.el.classList.contains('promo-tile--big')) continue;   /* sai da fila: é desmontada abaixo */
        var r = it.el.getBoundingClientRect();
        if (r.right > t.left && r.left < t.right) naTela.push(it); else perto.push(it);
      }
      var fila = naTela.concat(perto).slice(0, maxPrevias());
      for (var k = previasNoAr.length - 1; k >= 0; k--) {
        if (fila.indexOf(previasNoAr[k]) < 0) desmontaPrevia(previasNoAr[k]);
      }
      for (var j = 0; j < fila.length; j++) montaPrevia(fila[j]);
    }
    function agendaAtualizacao() {
      if (agendado) return;
      agendado = window.setTimeout(function () { agendado = null; atualizaPrevias(); }, 150);
    }
    function ligaPrevias() {
      if (semMovimento || economiaDeDados) return;   /* fica a capa com o selo de play */
      previasLigadas = true;
      if (!previas.length) registraPrevias();
      track.addEventListener('scroll', agendaAtualizacao, { passive: true });
      window.addEventListener('scroll', agendaAtualizacao, { passive: true });
      window.addEventListener('resize', agendaAtualizacao);
      atualizaPrevias();
    }
    function quandoOcioso(fn) {
      if (window.requestIdleCallback) window.requestIdleCallback(fn, { timeout: 2500 });
      else window.setTimeout(fn, 800);
    }
    if (document.readyState === 'complete') quandoOcioso(ligaPrevias);
    else window.addEventListener('load', function () { quandoOcioso(ligaPrevias); });

    /* ---------- Player de stories ---------- */
    var viewer = null, sessionSeq = 0;

    /* Ícones do som — iguais aos do player da PDP (assets/section-product.js) */
    var SVG_MUDO = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
    var SVG_SOM = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path><path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path></svg>';

    function buildViewer() {
      var el = document.createElement('div');
      el.className = 'vstory';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Vídeo do produto');
      el.setAttribute('tabindex', '-1');
      el.hidden = true;
      var tracks = '';
      for (var i = 0; i < items.length; i++) tracks += '<div class="vstory__track"><div class="vstory__fill" data-vs-fill></div></div>';
      el.innerHTML =
        '<button type="button" class="vstory__arrow vstory__arrow--prev" data-vs-prev aria-label="Anterior"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="15 18 9 12 15 6"></polyline></svg></button>' +
        '<div class="vstory__stage">' +
          '<div class="vstory__progress" aria-hidden="true">' + tracks + '</div>' +
          '<p class="vstory__title" data-vs-story-title></p>' +
          '<button type="button" class="vstory__close" data-vs-close aria-label="Fechar"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></button>' +
          '<div class="vstory__player" data-vs-player></div>' +
          '<button type="button" class="vstory__bigplay" data-vs-play hidden aria-label="Tocar vídeo"><svg viewBox="0 0 24 24" width="30" height="30" fill="currentColor" aria-hidden="true"><path d="M8 5v14l11-7z"></path></svg></button>' +
          '<button type="button" class="vstory__zone vstory__zone--prev" data-vs-prev aria-label="Anterior"></button>' +
          '<button type="button" class="vstory__zone vstory__zone--next" data-vs-next aria-label="Próximo"></button>' +
          '<div class="vstory__actions">' +
            '<button type="button" class="vstory__action" data-vs-mute aria-label="Ativar som">' + SVG_MUDO + '</button>' +
            '<button type="button" class="vstory__action" data-vs-cart aria-label="Adicionar ao carrinho"><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg></button>' +
          '</div>' +
          '<a class="vstory__product" data-vs-product><span class="vstory__product-name" data-vs-product-name></span><span class="vstory__product-price" data-vs-product-price></span></a>' +
          '<p class="vstory__toast" data-vs-toast role="status" aria-live="polite" hidden></p>' +
        '</div>' +
        '<button type="button" class="vstory__arrow vstory__arrow--next" data-vs-next aria-label="Próximo"><svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="9 18 15 12 9 6"></polyline></svg></button>';
      document.body.appendChild(el);
      return el;
    }

    var st = { open: false, index: 0, progress: 0, muted: true, session: null, opener: null, overflow: '', toastTimer: null };

    function els() {
      return {
        root: viewer,
        fills: viewer.querySelectorAll('[data-vs-fill]'),
        player: viewer.querySelector('[data-vs-player]'),
        mute: viewer.querySelector('[data-vs-mute]'),
        title: viewer.querySelector('[data-vs-story-title]'),
        product: viewer.querySelector('[data-vs-product]'),
        pname: viewer.querySelector('[data-vs-product-name]'),
        pprice: viewer.querySelector('[data-vs-product-price]'),
        toast: viewer.querySelector('[data-vs-toast]')
      };
    }

    function renderProgress(E) {
      var pr = Math.max(0, Math.min(1, st.progress));
      for (var t = 0; t < E.fills.length; t++) {
        E.fills[t].style.width = t < st.index ? '100%' : (t === st.index ? (pr * 100) + '%' : '0%');
      }
    }
    function renderMute(E) {
      E.mute.setAttribute('aria-label', st.muted ? 'Ativar som' : 'Silenciar');
      E.mute.innerHTML = st.muted ? SVG_MUDO : SVG_SOM;   /* o desenho precisa mudar: só o aria-label não aparece na tela */
    }
    function renderProduct(E) {
      var it = items[st.index];
      E.title.textContent = it.title || '';
      E.pname.textContent = it.name || '';
      E.pprice.textContent = it.price || '';
      if (it.url && it.url !== '#') { E.product.setAttribute('href', it.url); } else { E.product.removeAttribute('href'); }
      // esconde as bolinhas de progresso quando só há 1 vídeo
      viewer.querySelector('.vstory__progress').style.display = items.length > 1 ? '' : 'none';
      var singleZones = items.length > 1 ? '' : 'none';
      var z = viewer.querySelectorAll('.vstory__zone, .vstory__arrow');
      for (var i = 0; i < z.length; i++) z[i].style.display = singleZones;
    }

    function post(s, message) {
      if (!s || !s.iframe || !s.iframe.contentWindow) return;
      try { s.iframe.contentWindow.postMessage(JSON.stringify(message), '*'); } catch (e) {}
    }
    function unmount(E) {
      var s = st.session; st.session = null;
      if (s && s.timer) window.clearInterval(s.timer);
      if (s && s.vigia) window.clearTimeout(s.vigia);
      if (s && s.video) { try { s.video.pause(); } catch (e) {} }
      mostraPlay(false);
      if (E.player) E.player.innerHTML = '';
    }
    /* Player com vídeo da Shopify: um <video> nosso, reaproveitado entre um story e outro. O play() roda
       dentro do toque que abriu o player, então o iPhone deixa tocar COM som — e, como a liberação fica
       presa ao elemento, o próximo story também sai com som ao passar sozinho. No iPhone vai a lista HLS
       (a qualidade acompanha a internet); nos outros, a mp4 maior. Se o aparelho barrar, a resposta vem
       na hora (a promessa do play): cai para mudo e, por último, para o botão de play. */
    var videoDoPlayer = null;
    function pegaVideoDoPlayer() {
      if (videoDoPlayer) return videoDoPlayer;
      var v = document.createElement('video');
      v.className = 'vstory__video';
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'auto');
      v.addEventListener('playing', function () { var s = st.session; if (s && s.video === v) { marcaQueComecou(s); mostraPlay(false); } });
      /* Pausa que não veio de nós (ligação, Central de Controle, tirou o fone): mostra o play, senão o
         story fica parado sem saída. As nossas pausas acontecem com a sessão já encerrada. */
      v.addEventListener('pause', function () {
        var s = st.session;
        if (s && s.video === v && st.open && s.comecou && !v.ended) mostraPlay(true);
      });
      /* A fonte não abriu (rede, 404, HLS que o aparelho não decodifica): da lista HLS tenta a mp4 garantida;
         se nem ela abrir, passa para o próximo story. Não é bloqueio de som — não mexe no mudo. */
      v.addEventListener('error', function () {
        var s = st.session;
        if (!s || s.video !== v || !st.open) return;
        if (s.mp4 && v.getAttribute('src') !== s.mp4) { v.src = s.mp4; tocaNativo(s); return; }
        toast('Não foi possível carregar este vídeo');
        finish(s);
      });
      v.addEventListener('timeupdate', function () {
        var s = st.session;
        if (s && s.video === v && v.duration > 0) setProgress(s, Math.min(v.currentTime / v.duration, 1));
      });
      v.addEventListener('ended', function () { var s = st.session; if (s && s.video === v) finish(s); });
      videoDoPlayer = v;
      return v;
    }
    function montaNativo(E, it) {
      var v = pegaVideoDoPlayer();
      var s = { uid: ++sessionSeq, provider: 'shopify', video: v, mp4: it.v.src, ready: true, ended: false, comecou: false, vigia: null, mudo: st.muted };
      st.session = s;
      var capa = it.el.querySelector('.promo-tile__img');
      v.poster = capa ? (capa.currentSrc || capa.src || '') : '';
      v.muted = st.muted;
      v.src = (it.v.hls && v.canPlayType('application/vnd.apple.mpegurl')) ? it.v.hls : it.v.src;
      v.title = 'Vídeo ' + (st.index + 1);
      E.player.appendChild(v);
      tocaNativo(s);
    }
    function tocaNativo(s) {
      var v = s.video, pr;
      try { pr = v.play(); } catch (e) { pr = null; }
      if (!pr || !pr.catch) return;
      pr.catch(function (err) {
        if (st.session !== s) return;
        var nome = err && err.name;
        if (nome === 'AbortError') return;          /* trocou de vídeo no meio: não é bloqueio */
        if (nome !== 'NotAllowedError') return;     /* fonte que não abriu: quem cuida é o evento 'error' */
        if (!s.comecou && !v.muted) {
          v.muted = true; st.muted = true; s.mudo = true;
          renderMute(els());
          toast('Toque no alto-falante para ligar o som');
          tocaNativo(s);
          return;
        }
        mostraPlay(true);
      });
    }
    function paraDownloadDoPlayer() {
      if (!videoDoPlayer) return;
      try { videoDoPlayer.pause(); videoDoPlayer.removeAttribute('src'); videoDoPlayer.load(); } catch (e) {}
    }

    function mount(E) {
      unmount(E);
      var it = items[st.index];
      if (it.v.provider === 'shopify') { montaNativo(E, it); return; }
      var frame = document.createElement('iframe');
      frame.className = 'vstory__video';
      frame.title = 'Vídeo ' + (st.index + 1);
      frame.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture; encrypted-media');
      frame.setAttribute('frameborder', '0');
      frame.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      var s = { uid: ++sessionSeq, provider: it.v.provider, iframe: frame, ready: false, ended: false, duration: 0, timer: null, tries: 0, comecou: false, vigia: null, mudo: st.muted };
      st.session = s;
      frame.addEventListener('load', function () { if (st.session === s) handshake(s); });
      frame.src = embedSrc(it.v, st.muted);
      E.player.appendChild(frame);
    }
    /* iPhone/Safari não deixa um vídeo COM SOM começar sozinho. Quando ele barra, o iframe carrega mas
       nada toca — e com controls=0 não há botão de play: a pessoa vê um quadro parado. Então a gente
       confere se o vídeo engatou: se não engatou com som, recomeça MUDO (isso o iPhone deixa) e avisa
       como ligar o som; se nem mudo engatar, aparece um botão de play grande. */
    var ESPERA_PLAYER = 1800;
    function mostraPlay(mostra) {
      var b = viewer && viewer.querySelector('[data-vs-play]');
      if (b) b.hidden = !mostra;
    }
    function reiniciaVigia(s) {
      if (st.session !== s || s.comecou) return;
      if (s.vigia) window.clearTimeout(s.vigia);
      s.vigia = window.setTimeout(function () { naoComecou(s); }, ESPERA_PLAYER);
    }
    function marcaQueComecou(s) {
      if (st.session !== s || s.comecou) return;
      s.comecou = true;
      if (s.vigia) { window.clearTimeout(s.vigia); s.vigia = null; }
      mostraPlay(false);
    }
    function naoComecou(s) {
      if (st.session !== s || s.comecou) return;
      s.vigia = null;
      /* s.mudo é como ESTA tentativa subiu. Se fosse o st.muted, um toque no botão de som
         no meio do caminho fazia o código tentar mudo de novo, e o play nunca aparecia. */
      if (!s.mudo) { st.muted = true; recomecaMudo(); return; }
      mostraPlay(true);
    }
    /* Recomeça o mesmo vídeo mudo — é o que o aparelho deixa tocar — e diz onde ligar o som. */
    function recomecaMudo() {
      var E = els(); renderMute(E); st.progress = 0; renderProgress(E); mount(E);
      toast('Toque no alto-falante para ligar o som');
    }
    /* Botão de play: o toque nele é o gesto que o aparelho exige antes de deixar o vídeo rodar. */
    function tocaAgora() {
      var s = st.session;
      if (s && s.video) { mostraPlay(false); tocaNativo(s); return; }   /* o toque no botão é o gesto que libera */
      mostraPlay(false); st.muted = true; recomecaMudo();
    }

    function subscribeVimeo(s) {
      post(s, { method: 'addEventListener', value: 'timeupdate' });
      post(s, { method: 'addEventListener', value: 'play' });
      post(s, { method: 'addEventListener', value: 'ended' });
    }
    function handshake(s) {
      reiniciaVigia(s);
      if (s.provider === 'vimeo') { subscribeVimeo(s); return; }
      if (s.timer) window.clearInterval(s.timer);
      s.tries = 0;
      s.timer = window.setInterval(function () { ping(s); }, 250);
      ping(s);
    }
    function ping(s) {
      if (st.session !== s || s.ready || ++s.tries > 60) { if (s.timer) window.clearInterval(s.timer); s.timer = null; return; }
      post(s, { event: 'listening', id: s.uid, channel: 'widget' });
    }
    function setProgress(s, pr) {
      if (st.session !== s || !(pr >= 0)) return;
      st.progress = pr; renderProgress(els());
    }
    function finish(s) {
      if (st.session !== s || s.ended) return;
      s.ended = true; st.progress = 1; renderProgress(els()); go(st.index + 1);
    }
    function onYouTube(s, d) {
      if (d.event === 'readyToListen') { post(s, { event: 'listening', id: s.uid, channel: 'widget' }); return; }
      if (!s.ready) { s.ready = true; if (s.timer) window.clearInterval(s.timer); s.timer = null; post(s, { event: 'command', func: 'addEventListener', args: ['onStateChange'], id: s.uid, channel: 'widget' }); }
      var info = d.info;
      if (d.event === 'onStateChange') { if (info === 0) finish(s); return; }
      if ((d.event === 'infoDelivery' || d.event === 'initialDelivery') && info && typeof info === 'object') {
        if (typeof info.duration === 'number' && info.duration > 0) s.duration = info.duration;
        if (typeof info.currentTime === 'number' && s.duration > 0) setProgress(s, Math.min(info.currentTime / s.duration, 1));
        if (info.playerState === 1) marcaQueComecou(s);
        if (info.playerState === 0) finish(s);
      }
    }
    function onVimeo(s, d) {
      var ev = d.event;
      if (ev === 'ready') { s.ready = true; subscribeVimeo(s); reiniciaVigia(s); return; }
      if (!ev) return;
      s.ready = true;
      if (ev === 'play' || ev === 'playing') { marcaQueComecou(s); return; }
      if (ev === 'timeupdate' || ev === 'playProgress') {
        var data = d.data || {};
        if (data.seconds > 0) marcaQueComecou(s);
        var pr = typeof data.percent === 'number' ? data.percent : (data.duration > 0 ? data.seconds / data.duration : 0);
        setProgress(s, Math.min(pr, 1));
      } else if (ev === 'ended' || ev === 'finish') { finish(s); }
    }
    function handleMessage(e) {
      var s = st.session;
      if (!st.open || !s || !s.iframe || e.source !== s.iframe.contentWindow) return;
      var d = e.data;
      if (typeof d === 'string') { try { d = JSON.parse(d); } catch (err) { return; } }
      if (!d || typeof d !== 'object') return;
      if (s.provider === 'youtube') onYouTube(s, d); else onVimeo(s, d);
    }

    function go(index) {
      if (!st.open) return;
      if (index < 0 || index >= items.length) { close(); return; }
      st.index = index; st.progress = 0;
      var E = els();
      renderProgress(E); renderProduct(E); mount(E);
    }
    function toggleMute() {
      st.muted = !st.muted; var E = els(); renderMute(E);
      toast(st.muted ? 'Som desativado' : 'Som ativado');
      var s = st.session;
      if (s && s.video) {
        /* vídeo nosso: troca o som na hora; se estava parado, o toque no alto-falante já faz tocar */
        s.video.muted = st.muted;
        s.mudo = st.muted;
        if (!st.muted) s.video.volume = 1;
        if (s.video.paused) tocaNativo(s);
        return;
      }
      if (s && s.ready) {
        // player já conversa por mensagem: troca o som sem recarregar, e o vídeo não volta ao início
        if (s.provider === 'youtube') {
          post(s, { event: 'command', func: st.muted ? 'mute' : 'unMute', args: [], id: s.uid, channel: 'widget' });
        } else {
          post(s, { method: 'setMuted', value: st.muted });
          post(s, { method: 'setVolume', value: st.muted ? 0 : 1 });
        }
        return;
      }
      // sem canal de mensagens ainda: recria o iframe com o parâmetro de som (mesma técnica do player do produto)
      st.progress = 0; renderProgress(E); mount(E);
    }
    function toast(msg) {
      var E = els();
      if (!E.toast) return;
      E.toast.textContent = msg; E.toast.hidden = false;
      if (st.toastTimer) window.clearTimeout(st.toastTimer);
      st.toastTimer = window.setTimeout(function () { E.toast.hidden = true; }, 2500);
    }

    function open(index, opener) {
      if (!viewer) {
        viewer = buildViewer();
        wireViewer();
        window.addEventListener('message', handleMessage);
      }
      st.open = true; st.opener = opener || null; st.muted = false;   /* abre COM SOM: o vídeo foi pedido num toque */
      desmontaTodasAsPrevias();   /* com o player aberto, as prévias da vitrine não precisam gastar CPU */
      viewer.hidden = false;
      st.overflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      renderMute(els());
      go(index);
      try { viewer.focus(); } catch (e) {}
    }
    function close() {
      st.open = false;
      var E = els();
      unmount(E);
      paraDownloadDoPlayer();
      viewer.hidden = true;
      document.body.style.overflow = st.overflow || '';
      if (st.toastTimer) { window.clearTimeout(st.toastTimer); E.toast.hidden = true; }
      if (st.opener && st.opener.focus) { try { st.opener.focus(); } catch (e) {} }
      atualizaPrevias();          /* player fechado: as prévias do que está na tela voltam */
    }

    function wireViewer() {
      viewer.addEventListener('click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[data-vs-close]')) { close(); return; }
        if (t.closest('[data-vs-prev]')) { go(st.index - 1); return; }
        if (t.closest('[data-vs-next]')) { go(st.index + 1); return; }
        if (t.closest('[data-vs-play]')) { tocaAgora(); return; }
        if (t.closest('[data-vs-mute]')) { toggleMute(); return; }
        if (t.closest('[data-vs-cart]')) {
          var it = items[st.index];
          if (!it.variant) { toast('Produto indisponível'); return; }
          addToCart(it.variant).then(function () { toast('Produto adicionado ao carrinho'); }, function () { toast('Não foi possível adicionar'); });
          return;
        }
      });
      document.addEventListener('keydown', function (e) {
        if (!st.open) return;
        if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowRight' || e.key === 'Right') { e.preventDefault(); go(st.index + 1); }
        else if (e.key === 'ArrowLeft' || e.key === 'Left') { e.preventDefault(); go(st.index - 1); }
      });
    }

    // Abre o player ao clicar num tile de vídeo
    track.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-vs-open]');
      if (!opener) return;
      e.preventDefault();
      var idx = parseInt(opener.getAttribute('data-vs-open'), 10) || 0;
      open(idx, opener);
    });
  }

  window.F5PromoGrid = { liga: liga };
  Array.prototype.forEach.call(document.querySelectorAll('[data-promo]'), liga);
  document.addEventListener('shopify:section:load', function (e) {
    Array.prototype.forEach.call((e.target || document).querySelectorAll('[data-promo]'), liga);
  });
}());
